<!--title -->
<app-modal-title
  [title]="formPageConfig.title | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div mat-dialog-content class="dialog-content">
  <!-- form -->
  <form [formGroup]="form">
    <div class="row">
      <div class="tw-w-full">
        <div class="tw-flex-center tw-flex-col">
          <div class="tw-w-[350px]">
            <app-chip-list
              [title]="'common.wordList' | translate"
              placeholder="messages.separateByEnter"
              [checkInputWhenBlur]="true"
              [checkMobileNumbers]="false"
              [separateByComma]="false"
              [outputAsArray]="true"
              (items)="model.titles = $event"
            >
            </app-chip-list>
          </div>
        </div>
      </div>
    </div>

    <!-- form btns-->
    <app-form-btns
      [loading]="loading"
      [form]="form"
      [isEdit]="formPageConfig.isEditMode"
      (onClose)="onClose()"
      (onSubmit)="onSubmit()"
    >
    </app-form-btns>
  </form>
</div>
